export class OTA_VehMakeModel {
    public name: string;
    public modelYear: number;
    public code: string;
}
